import { BaseError } from "../helpers/Error"

export const ACTION_SENT: ActionStatus = "action-sent"
export const ACTION_FAIL: ActionStatus = "action-fail"
export const ACTION_SUCCESS: ActionStatus = "action-success"
export const ACTION_NULL : ActionStatus = "action-null"

type ActionStatus = 
    "action-sent" 
    | "action-fail" 
    | "action-success"
    | "action-null"

export type ActionLog = {
    readonly actionId: string
    readonly status: ActionStatus
    readonly time: number
    readonly result?: object
    readonly error?: BaseError
}

export function createNullAction(actionId: string): ActionLog {
    return {
        actionId: actionId,
        time: Date.now(),
        status: ACTION_NULL,
    }
}

export function isActionLoading(action: ActionLog) {
    return action.status == ACTION_SENT
}

export function isActionSuccess(action: ActionLog) {
    return action.status == ACTION_SUCCESS
}

export function isActionSuccessTimeout(action: ActionLog, timeout: number) {
    const isInTimeoutWindow = (Date.now() - action.time) < timeout
    return isInTimeoutWindow && action.status == ACTION_SUCCESS
}


// WEBPACK FOOTER //
// ./src/state/actionlog/ActionLog.ts